class V105Tool {
	constructor(container, ctx, canvas, skipDefaultImage = false) {
		this.container = container;
		this.ctx = ctx;
		this.canvas = canvas;
		this.originalImageData = null;
		this.currentImageData = null;
		this.defaultImageData = null; // Store default image data
		this.imgWidth = 0;
		this.imgHeight = 0;
		this.render();
		this.initEventListeners();
		// Only load default image if not skipping and no current image exists
		if (!skipDefaultImage) {
			this.loadDefaultImage();
		}
	}
	// Create and load a default image
	loadDefaultImage() {
		const defaultImg = this.createDefaultImage();
		// Wait for the image to load before processing
		defaultImg.onload = () => {
			this.onImageUpload(defaultImg);
			// Store the default image data for later restoration
			this.storeDefaultImageData();
			// Wait for V105Filters library to be available, then apply filters
			const checkAndApplyFilters = () => {
				if (window.V105Filters && this.processedPixels) {
					this.applyFilters();
				} else {
					// Retry after a short delay if library not ready
					setTimeout(checkAndApplyFilters, 50);
				}
			};
			checkAndApplyFilters();
		};
	}
	// Store default image data for later restoration
	storeDefaultImageData() {
		if (this.originalImageData) {
			this.defaultImageData = new ImageData(
				new Uint8ClampedArray(this.originalImageData.data),
				this.originalImageData.width,
				this.originalImageData.height
			);
		}
	}
	// Restore default image
	restoreDefaultImage() {
		if (this.defaultImageData) {
			// Restore the default image data
			this.originalImageData = new ImageData(
				new Uint8ClampedArray(this.defaultImageData.data),
				this.defaultImageData.width,
				this.defaultImageData.height
			);
			this.processedPixels = new Uint8ClampedArray(this.defaultImageData.data);
			// Update canvas dimensions if needed
			if (
				this.defaultImageData.width !== this.imgWidth ||
				this.defaultImageData.height !== this.imgHeight
			) {
				this.imgWidth = this.defaultImageData.width;
				this.imgHeight = this.defaultImageData.height;
				this.canvas.width = this.imgWidth;
				this.canvas.height = this.imgHeight;
			}
			// Apply the default image to canvas
			this.ctx.putImageData(this.originalImageData, 0, 0);
			this.applyFilters();
		} else {
			// Fallback to loading the default image if data not stored
			this.loadDefaultImage();
		}
	}
	// Create a default image with a gradient pattern
	createDefaultImage() {
		// Create an image element and load the upload.png file
		const img = new Image();
		img.src = "//www.campsnapphoto.com/cdn/shop/t/115/assets/upload.png?v=49794882534667258901763448499";
		return img;
	}
	render() {
		this.container.innerHTML = `
							<div class="tool-section">
									<div style="display: none;">
											<table id="colorCorrectionMatrixTable" class="matrix-table">
													<caption>Color Correction Matrix</caption>
													<tbody></tbody>
											</table>
											<table id="segDLookupTable" class="matrix-table">
													<caption>Segmented Lookup Table</caption>
													<tbody></tbody>
											</table>
									</div>
									<!-- Brightness slider -->
									<div class="slider-group">
											<div class="slider-label">
													<span><img src="//www.campsnapphoto.com/cdn/shop/t/115/assets/brightness_icon.png?v=36298" alt="" /> Brightness:</span>
													<span id="brightnessValue">0</span>
											</div>
											<input type="range" id="brightness" class="slider" min="-255" max="255" value="0">
									</div>
									<!-- Contrast slider -->
									<div class="slider-group">
											<div class="slider-label">
													<span><img src="//www.campsnapphoto.com/cdn/shop/t/115/assets/contrast_icon.png?v=36298" alt="" /> Contrast:</span>
													<span id="contrastValue">1.0</span>
											</div>
											<input type="range" id="contrast" class="slider" min="0.0" max="2.0" step="0.01" value="1.0">
									</div>
									<!-- Saturation slider -->
									<div class="slider-group">
											<div class="slider-label">
													<span><img src="//www.campsnapphoto.com/cdn/shop/t/115/assets/saturation_icon.png?v=36298" alt="" /> Saturation:</span>
													<span id="saturationValue">1.0</span>
											</div>
											<input type="range" id="saturation" class="slider" min="0.0" max="4.0" step="0.01" value="1.0">
									</div>
									<!-- HUE slider -->
									<div class="slider-group">
											<div class="slider-label">
													<span><img src="//www.campsnapphoto.com/cdn/shop/t/115/assets/hue_icon.png?v=36298" alt="" /> Hue:</span>
													<span id="hueValue">0</span>
											</div>
											<input type="range" id="hue" class="slider" min="0" max="360" value="0">
									</div>
									<!-- Gamma slider -->
									<div class="slider-group">
											<div class="slider-label">
													<span><img src="//www.campsnapphoto.com/cdn/shop/t/115/assets/gamma_icon.png?v=36298" alt="" /> GammaR:</span>
													<span id="gammaRValues">1.0</span>
											</div>
											<input type="range" id="gammaR" class="slider" min="0.1" max="2.0" step="0.01" value="1.0" title="Red">
									</div>
									<div class="slider-group">
											<div class="slider-label">
													<span><img src="//www.campsnapphoto.com/cdn/shop/t/115/assets/gamma_icon.png?v=36298" alt="" /> GammaG:</span>
													<span id="gammaGValues">1.0</span>
											</div>
											<input type="range" id="gammaG" class="slider" min="0.1" max="2.0" step="0.01" value="1.0" title="Green">
									</div>
									<div class="slider-group">
											<div class="slider-label">
													<span><img src="//www.campsnapphoto.com/cdn/shop/t/115/assets/gamma_icon.png?v=36298" alt="" /> GammaB:</span>
													<span id="gammaBValues">1.0</span>
											</div>
											<input type="range" id="gammaB" class="slider" min="0.1" max="2.0" step="0.01" value="1.0" title="Blue">
									</div>
									<!-- The Grain effect will cause the camera to lag, so it will not be used temporarily. -->
									<div class="slider-group" style="display: none;">
											<div class="slider-label">
													<span>Grain:</span>
													<span id="grainValue">0</span>
											</div>
											<input type="range" id="grain" class="slider" min="0" max="64" step="1" value="0" title="Grain">
									</div>
																		 <!-- Button group -->
																		 <div class="button-group">
											<button id="loadButton" class="import-button btn v3">Load Filter</button>
											<input type="file" id="filterUpload" accept=".flt" style="display: none;">
											<button id="resetButton" class="reset-button btn v2">Reset</button>
											<button id="exportButton" class="export-button btn">Save Filter</button>
									</div>
									<!-- Special effect selection -->
									<div class="radio-group">
											<label>
													<input type="radio" name="effect" id="standardEffect" value="standard">
													<span><img src="//www.campsnapphoto.com/cdn/shop/t/115/assets/standard_icon.png?v=36298" alt="" /> Standard</span>
											</label>
											<label>
													<input type="radio" name="effect" id="retroEffect" value="retro">
													<span><img src="//www.campsnapphoto.com/cdn/shop/t/115/assets/retro_icon.png?v=36298" alt="" /> Retro</span>
											</label>
											<label>
													<input type="radio" name="effect" id="grayEffect" value="gray">
													<span><img src="//www.campsnapphoto.com/cdn/shop/t/115/assets/grayscale_icon.png?v=36298" alt="" /> Grayscale</span>
											</label>
									</div>
							</div>
					`;
	}
	initEventListeners() {
		// controls
		this.brightnessControl = this.container.querySelector("#brightness");
		this.contrastControl = this.container.querySelector("#contrast");
		this.saturationControl = this.container.querySelector("#saturation");
		this.hueControl = this.container.querySelector("#hue");
		this.gammaRControl = this.container.querySelector("#gammaR");
		this.gammaGControl = this.container.querySelector("#gammaG");
		this.gammaBControl = this.container.querySelector("#gammaB");
		this.grainControl = this.container.querySelector("#grain");
		// displays
		this.brightnessValue = this.container.querySelector("#brightnessValue");
		this.contrastValue = this.container.querySelector("#contrastValue");
		this.saturationValue = this.container.querySelector("#saturationValue");
		this.hueValue = this.container.querySelector("#hueValue");
		this.gammaRValues = this.container.querySelector("#gammaRValues");
		this.gammaGValues = this.container.querySelector("#gammaGValues");
		this.gammaBValues = this.container.querySelector("#gammaBValues");
		this.grainValue = this.container.querySelector("#grainValue");
		// other UI
		this.resetButton = this.container.querySelector("#resetButton");
		this.exportButton = this.container.querySelector("#exportButton");
		this.effectRadios = this.container.querySelectorAll('input[name="effect"]');
		// plain button listeners (no plugin)
		this.resetButton.addEventListener("click", () => this.resetFilters());
		this.exportButton.addEventListener("click", () => this.exportTablesAsTxt());
		this.effectRadios.forEach((radio) =>
			radio.addEventListener("change", () => this.handleEffectChange())
		);
		// File upload controls
		const loadButton = this.container.querySelector("#loadButton");
		const filterUpload = this.container.querySelector("#filterUpload");
		loadButton.addEventListener("click", () => filterUpload.click());
		filterUpload.addEventListener("change", (e) => this.handleFilterUpload(e));
		// Helper to wire a control + value display to rangeslider plugin
		const wireSlider = (inputEl, displayEl, handlerName = "updateValue") => {
			if (!inputEl) return;
			const $input = $(inputEl);
			const stepValue = parseFloat($input.attr('step')) || 1;
			// init display with current value
			displayEl && (displayEl.textContent = inputEl.value);
			// init plugin (polyfill false forces plugin UI)
			console.log('Step Value: ', stepValue);
			$input.rangeslider({
				polyfill: false,
				onInit: (position, value) => {
					// ensure display shows initial value (value may be undefined in some builds)
					const val = (typeof value !== "undefined") ? value : inputEl.value;
					if (handlerName === "updateGamma") {
						this.updateGammaValues();
					} else if (handlerName === "applyFiltersOnly") {
						this.applyFilters();
					} else {
						// call updateValue(control, display, numericValue)
						this.updateValue(inputEl, displayEl, val);
					}
				},
				onSlide: (position, value) => {
					const val = (typeof value !== "undefined") ? value : inputEl.value;
					if (handlerName === "updateGamma") {
						// update gamma display and apply
						this.updateGammaValues();
					} else if (handlerName === "applyFiltersOnly") {
						this.applyFilters();
					} else {
						this.updateValue(inputEl, displayEl, val);
					}
				},
				onSlideEnd: (position, value) => {
					const val = (typeof value !== "undefined") ? value : inputEl.value;
					if (handlerName === "updateGamma") {
						this.updateGammaValues();
					} else if (handlerName === "applyFiltersOnly") {
						this.applyFilters();
					} else {
						this.updateValue(inputEl, displayEl, val);
					}
				}
			});
			// Also listen to change event (useful when value set programmatically and plugin not triggering callbacks)
			inputEl.addEventListener("change", () => {
				const val = inputEl.value;
				if (handlerName === "updateGamma") {
					this.updateGammaValues();
				} else if (handlerName === "applyFiltersOnly") {
					this.applyFilters();
				} else {
					this.updateValue(inputEl, displayEl, val);
				}
			});
		};
		// Wire all sliders. For gamma controls we want updateGamma behavior.
		wireSlider(this.brightnessControl, this.brightnessValue, "updateValue");
		wireSlider(this.contrastControl, this.contrastValue, "updateValue");
		wireSlider(this.saturationControl, this.saturationValue, "updateValue");
		wireSlider(this.hueControl, this.hueValue, "updateValue");
		wireSlider(this.gammaRControl, this.gammaRValues, "updateGamma");
		wireSlider(this.gammaGControl, this.gammaGValues, "updateGamma");
		wireSlider(this.gammaBControl, this.gammaBValues, "updateGamma");
		wireSlider(this.grainControl, this.grainValue, "applyFiltersOnly");
		// If you later update values programmatically, use this helper so plugin + handlers update:
		this.updateSliderProgrammatically = (inputEl, newValue) => {
			const $input = $(inputEl);
			inputEl.value = newValue;
			// Update plugin UI and then trigger change so listeners run
			$input.rangeslider('update');   // redraw
			inputEl.dispatchEvent(new Event('change', { bubbles: true })); // run our change listener
		};
	}
	onImageUpload(img) {
		this.imgWidth = img.width;
		this.imgHeight = img.height;
		this.canvas.width = this.imgWidth;
		this.canvas.height = this.imgHeight;
		this.ctx.drawImage(img, 0, 0);
		const imageData = this.ctx.getImageData(
			0,
			0,
			this.imgWidth,
			this.imgHeight
		);
		this.preprocessImage(imageData);
		this.processedPixels = new Uint8ClampedArray(imageData.data);
		this.ctx.putImageData(imageData, 0, 0);
		this.applyFilters();
		this.originalImage = img;
	}
	preprocessImage(imageData) {
		if (window.V105Filters?.applyInverseGammaTableRGBA) {
			window.V105Filters.applyInverseGammaTableRGBA(
				imageData.data,
				imageData.width,
				imageData.height,
				window.V105Filters.gamma_table
			);
		}
	}
	applyFilters() {
		[this.gammaRControl, this.gammaGControl, this.gammaBControl].forEach(
			(control) => {
				if (control.value === "1") {
					control.value = "1.0";
					const display =
						control === this.gammaRControl
							? this.gammaRValues
							: control === this.gammaGControl
							? this.gammaGValues
							: this.gammaBValues;
					display.textContent = "1.0";
				}
			}
		);
		if (!this.processedPixels) return;
		const imageData = this.ctx.getImageData(
			0,
			0,
			this.imgWidth,
			this.imgHeight
		);
		const pixels = imageData.data;
		pixels.set(this.processedPixels);
		const brightness = parseFloat(this.brightnessControl.value);
		const contrast = parseFloat(this.contrastControl.value);
		const saturation = parseFloat(this.saturationControl.value);
		const hue = parseFloat(this.hueControl.value);
		const gammaR = parseFloat(this.gammaRControl.value);
		const gammaG = parseFloat(this.gammaGControl.value);
		const gammaB = parseFloat(this.gammaBControl.value);
		const grain = parseFloat(this.grainControl.value);
		const selectedEffect = this.container.querySelector('input[name="effect"]:checked')?.value || 'custom';
		if (window.V105Filters?.makeCCMatrix && window.V105Filters?.applyMatrix) {
			const colorCorrectionMatrix = Array.from({ length: 3 }, () =>
				Array(3).fill(0)
			);
			window.V105Filters.makeCCMatrix(saturation, hue, colorCorrectionMatrix);
			window.V105Filters.applyMatrix(
				pixels,
				this.imgWidth,
				this.imgHeight,
				colorCorrectionMatrix
			);
		}
		if (window.V105Filters?.applyGammaTableRGBA) {
			window.V105Filters.applyGammaTableRGBA(
				pixels,
				this.imgWidth,
				this.imgHeight,
				window.V105Filters.gamma_table
			);
		}
		if (
			window.V105Filters?.makeSegDLookupTable &&
			window.V105Filters?.applySegDLookupTableRGBA
		) {
			const segDLookupTable = Array.from({ length: 256 }, () =>
				Array(3).fill(0)
			);
			if (
				selectedEffect === "retro" &&
				window.V105Filters?.makeRetroSegLookupTable
			) {
				window.V105Filters.makeRetroSegLookupTable(segDLookupTable);
			} else {
				window.V105Filters.makeSegDLookupTable(
					brightness,
					contrast,
					gammaR,
					gammaG,
					gammaB,
					segDLookupTable
				);
			}
			window.V105Filters.applySegDLookupTableRGBA(
				pixels,
				this.imgWidth,
				this.imgHeight,
				segDLookupTable
			);
		}
		if (window.V105Filters?.applyGrainLevelNoise) {
			window.V105Filters.applyGrainLevelNoise(
				pixels,
				this.imgWidth,
				this.imgHeight,
				grain,
				this.imgWidth,
				this.imgHeight
			);
		}
		this.ctx.putImageData(imageData, 0, 0);
	}
	updateValue(control, display) {
		display.textContent = control.value;
		this.applyFilters();
	}
	updateGammaValues() {
		const selectedEffect = this.container.querySelector('input[name="effect"]:checked')?.value || 'custom';
		console.log(this);
		if (selectedEffect === "gray") {
			const unifiedGammaValue = this.gammaRControl.value;
			this.updateSliderProgrammatically(this.gammaGControl, unifiedGammaValue);
			this.updateSliderProgrammatically(this.gammaBControl, unifiedGammaValue);
		}
		this.gammaRValues.textContent = this.gammaRControl.value;
		this.gammaGValues.textContent = this.gammaGControl.value;
		this.gammaBValues.textContent = this.gammaBControl.value;
		this.applyFilters();
	}
	resetFilters() {
		this.updateSliderProgrammatically(this.brightnessControl, 0);
		this.updateSliderProgrammatically(this.contrastControl, 1.0);
		this.updateSliderProgrammatically(this.saturationControl, 1.0);
		this.updateSliderProgrammatically(this.gammaRControl, 1.0);
		this.updateSliderProgrammatically(this.gammaGControl, 1.0);
		this.updateSliderProgrammatically(this.gammaBControl, 1.0);
		this.updateSliderProgrammatically(this.hueControl, 0);
		this.updateSliderProgrammatically(this.grainControl, 0);
		
		this.container.querySelector("#customEffect").checked = true;
		this.handleEffectChange();
	}
	handleEffectChange() {
		const selectedEffect = this.container.querySelector('input[name="effect"]:checked')?.value || 'custom';
		this.brightnessControl.disabled = false;
		this.contrastControl.disabled = false;
		this.saturationControl.disabled = false;
		this.hueControl.disabled = false;
		this.gammaRControl.disabled = false;
		this.gammaGControl.disabled = false;
		this.gammaBControl.disabled = false;
		this.grainControl.disabled = false;
		switch (selectedEffect) {
			case "custom":
				break;
			case "standard":
				this.updateSliderProgrammatically(this.brightnessControl, 0);
				this.updateSliderProgrammatically(this.contrastControl, 1.0);
				this.updateSliderProgrammatically(this.saturationControl, 1.0);
				this.updateSliderProgrammatically(this.gammaRControl, 1.0);
				this.updateSliderProgrammatically(this.gammaGControl, 1.0);
				this.updateSliderProgrammatically(this.gammaBControl, 1.0);
				this.updateSliderProgrammatically(this.hueControl, 0);
				this.updateSliderProgrammatically(this.grainControl, 0);
				break;
			case "retro":
				this.updateSliderProgrammatically(this.brightnessControl, 0);
				this.updateSliderProgrammatically(this.contrastControl, 1.0);
				this.updateSliderProgrammatically(this.gammaRControl, 1.0);
				this.updateSliderProgrammatically(this.gammaGControl, 1.0);
				this.updateSliderProgrammatically(this.gammaBControl, 1.0);
				
				this.brightnessControl.disabled = true;
				this.contrastControl.disabled = true;
				this.gammaRControl.disabled = true;
				this.gammaGControl.disabled = true;
				this.gammaBControl.disabled = true;
				break;
			case "gray":
				this.updateSliderProgrammatically(this.saturationControl, 0);
				this.updateSliderProgrammatically(this.gammaGControl, 1.0);
				this.updateSliderProgrammatically(this.gammaBControl, 1.0);
				
				this.saturationControl.disabled = true;
				this.hueControl.disabled = true;
				this.gammaGControl.disabled = true;
				this.gammaBControl.disabled = true;
				break;
		}
		this.applyFilters();
	}
	async exportTablesAsTxt() {
		try {
			const colorCorrectionMatrix = Array.from({ length: 3 }, () =>
				Array(3).fill(0)
			);
			if (window.V105Filters?.makeCCMatrix) {
				const saturation = parseFloat(this.saturationControl.value);
				const hue = parseFloat(this.hueControl.value);
				window.V105Filters.makeCCMatrix(saturation, hue, colorCorrectionMatrix);
			}
			this.updateHiddenTable(
				"colorCorrectionMatrixTable",
				colorCorrectionMatrix
			);
			const segDLookupTable = Array.from({ length: 256 }, () =>
				Array(3).fill(0)
			);
			const brightness = parseFloat(this.brightnessControl.value);
			const contrast = parseFloat(this.contrastControl.value);
			const saturation = parseFloat(this.saturationControl.value);
			const hue = parseFloat(this.hueControl.value);
			const gammaR = parseFloat(this.gammaRControl.value);
			const gammaG = parseFloat(this.gammaGControl.value);
			const gammaB = parseFloat(this.gammaBControl.value);
			// const grain = parseFloat(this.grainControl.value); // Not used in expected format
			if (window.V105Filters?.makeSegDLookupTable) {
				window.V105Filters.makeSegDLookupTable(
					brightness,
					contrast,
					gammaR,
					gammaG,
					gammaB,
					segDLookupTable
				);
			}
			this.updateHiddenSegTable("segDLookupTable", segDLookupTable);
			// Extract matrix and LUT data as comma-separated lines
			const colorCorrectionMatrixData = this.extractMatrixData(
				"colorCorrectionMatrixTable",
				1024
			);
			const segDLookupTableData = this.extractSegTableData("segDLookupTable");
			// First line: parameters as comma-separated values (order: brightness, contrast, saturation, hue, gammaR, gammaG, gammaB)
			const paramLine = [
				brightness,
				contrast,
				saturation,
				hue,
				gammaR,
				gammaG,
				gammaB,
			].join(", ");
			// Compose content in expected format
			const content = [
				paramLine,
				colorCorrectionMatrixData,
				segDLookupTableData,
			].join("\n");
			console.log("content:", content);
			if (window.showSaveFilePicker) {
				try {
					const handle = await window.showSaveFilePicker({
						suggestedName: "table.flt",
						types: [
							{ description: "FLT Files", accept: { "text/plain": [".flt"] } },
						],
					});
					const writable = await handle.createWritable();
					await writable.write(content);
					await writable.close();
					return;
				} catch (error) {
					if (error.name !== "AbortError") {
						throw error;
					}
					return;
				}
			} else {
				// 只有在不支持showSaveFilePicker时才使用备用方案
				this.startDownload(content);
			}
		} catch (error) {
			console.error("Export failed:", error);
		}
	}
	startDownload(content) {
		var blob = new Blob([content], { type: "text/plain" });
		var url = URL.createObjectURL(blob);
		var link = document.createElement("a");
		link.href = url;
		link.download = "table.flt";
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		setTimeout(function () {
			URL.revokeObjectURL(url);
		}, 100);
	}
	updateHiddenTable(tableId, matrix) {
		const table = this.container.querySelector(`#${tableId}`);
		const tbody = table.querySelector("tbody");
		tbody.innerHTML = "";
		matrix.forEach((row) => {
			const tr = document.createElement("tr");
			row.forEach((value) => {
				const td = document.createElement("td");
				td.textContent = value.toFixed(2);
				tr.appendChild(td);
			});
			tbody.appendChild(tr);
		});
	}
	updateHiddenSegTable(tableId, tableData) {
		const table = this.container.querySelector(`#${tableId}`);
		const tbody = table.querySelector("tbody");
		tbody.innerHTML = "";
		["R", "G", "B"].forEach((color, colorIndex) => {
			const tr = document.createElement("tr");
			const labelTd = document.createElement("td");
			labelTd.textContent = `${color}:`;
			tr.appendChild(labelTd);
			tableData.forEach((row) => {
				const td = document.createElement("td");
				td.textContent = row[colorIndex].toFixed(2);
				tr.appendChild(td);
			});
			tbody.appendChild(tr);
		});
	}
	extractMatrixData(tableId, scaleFactor = 1024) {
		const table = this.container.querySelector(`#${tableId}`);
		const rows = table.querySelectorAll("tbody tr");
		let matrixData = "";
		rows.forEach((row, rowIndex) => {
			const cells = Array.from(row.querySelectorAll("td")).map((cell) =>
				Math.round(parseFloat(cell.textContent.trim()) * scaleFactor)
			);
			matrixData += `${cells.join(", ")}${
				rowIndex < rows.length - 1 ? ", " : ""
			}\n`;
		});
		return matrixData.trim();
	}
	extractSegTableData(tableId) {
		const table = this.container.querySelector(`#${tableId}`);
		const rows = table.querySelectorAll("tbody tr");
		let segData = "";
		const colorData = {
			R: [],
			G: [],
			B: [],
		};
		rows.forEach((row, rowIndex) => {
			const cells = row.querySelectorAll("td");
			if (cells[0].textContent.includes("R:")) {
				for (let i = 1; i < cells.length; i++) {
					colorData.R.push(Math.round(parseFloat(cells[i].textContent.trim())));
				}
			} else if (cells[0].textContent.includes("G:")) {
				for (let i = 1; i < cells.length; i++) {
					colorData.G.push(Math.round(parseFloat(cells[i].textContent.trim())));
				}
			} else if (cells[0].textContent.includes("B:")) {
				for (let i = 1; i < cells.length; i++) {
					colorData.B.push(Math.round(parseFloat(cells[i].textContent.trim())));
				}
			}
		});
		segData += `${colorData.R.join(", ")}\n`;
		segData += `${colorData.G.join(", ")}\n`;
		segData += `${colorData.B.join(", ")}`;
		return segData.trim();
	}
	handleFilterUpload(event) {
		const file = event.target.files[0];
		if (!file) return;
		event.target.value = "";
		const reader = new FileReader();
		reader.onload = (e) => {
			try {
				console.log("Starting to parse FLT file...");
				const content = e.target.result;
				const filterData = this.parseFilterData(content);
				console.log("Successfully parsed filter data:", filterData);
				this.updateControls(filterData);
				this.applyFiltersByValues(
					filterData.brightness,
					filterData.contrast,
					filterData.saturation,
					filterData.hue,
					filterData.gammaR,
					filterData.gammaG,
					filterData.gammaB,
					filterData.colorCorrectionMatrix,
					filterData.segDLookupMatrix
				);
				console.log("Filter applied successfully");
			} catch (error) {
				console.error("Error loading filter file:", error);
				alert(`Error loading filter: ${error.message}`);
			}
		};
		reader.onerror = () => {
			console.error("File reading error:", reader.error);
			alert("Error reading file");
		};
		reader.readAsText(file);
	}
	parseFilterData(content) {
		console.log("Raw FLT file content:", content);
		const lines = content
			.split("\n")
			.map((line) => line.trim())
			.filter((line) => line !== "");
		console.log("Lines after split:", lines);
		if (lines.length < 3) {
			throw new Error("Invalid FLT format: Expected at least 3 lines");
		}
		// Parse the first line which contains the 7 parameters
		const paramLine = lines[0];
		const paramValues = paramLine
			.split(",")
			.map((val) => val.trim())
			.filter((val) => val !== "");
		if (paramValues.length !== 7) {
			throw new Error(
				`Invalid FLT format: Expected 7 parameters, got ${paramValues.length}`
			);
		}
		// Parse parameters
		const [brightness, contrast, saturation, hue, gammaR, gammaG, gammaB] =
			paramValues.map((val) => this.parseValue(val));
		// Parse matrix and LUT data from remaining lines
		let allValues = [];
		for (let i = 1; i < lines.length; i++) {
			const lineValues = lines[i]
				.split(",")
				.map((val) => val.trim())
				.filter((val) => val !== "");
			allValues = [...allValues, ...lineValues];
		}
		console.log("All parsed values count:", allValues.length);
		console.log("First 20 values:", allValues.slice(0, 20));
		if (allValues.length !== 777) {
			console.error(
				"Invalid FLT format: Expected 777 values (9 matrix + 768 LUT)"
			);
			throw new Error(
				`Invalid FLT format: Got ${allValues.length} values, expected 777`
			);
		}
		const colorCorrectionMatrix = [
			[
				this.parseValue(allValues[0]),
				this.parseValue(allValues[1]),
				this.parseValue(allValues[2]),
			],
			[
				this.parseValue(allValues[3]),
				this.parseValue(allValues[4]),
				this.parseValue(allValues[5]),
			],
			[
				this.parseValue(allValues[6]),
				this.parseValue(allValues[7]),
				this.parseValue(allValues[8]),
			],
		];
		console.log("Parsed color correction matrix:", colorCorrectionMatrix);
		const segDLookupMatrix = [
			allValues.slice(9, 265).map((val) => this.parseValue(val)),
			allValues.slice(265, 521).map((val) => this.parseValue(val)),
			allValues.slice(521, 777).map((val) => this.parseValue(val)),
		];
		console.log("First 5 values of each lookup channel:", {
			R: segDLookupMatrix[0].slice(0, 5),
			G: segDLookupMatrix[1].slice(0, 5),
			B: segDLookupMatrix[2].slice(0, 5),
		});
		const controlValues = {
			brightness,
			contrast,
			saturation,
			hue,
			gammaR,
			gammaG,
			gammaB,
			grain: 0, // Default value
			effect: "custom", // Default value
		};
		console.log("Parsed control values:", controlValues);
		return {
			...controlValues,
			colorCorrectionMatrix,
			segDLookupMatrix,
		};
	}
	parseValue(val) {
		const num = parseFloat(val);
		if (isNaN(num)) {
			console.warn("Invalid number value:", val);
			return 0;
		}
		return num;
	}
	updateControls(filterData) {
		this.updateSliderProgrammatically(this.brightnessControl, 
			isNaN(filterData.brightness) ? 0 : filterData.brightness);
		this.updateSliderProgrammatically(this.contrastControl, 
			isNaN(filterData.contrast) ? 1.0 : filterData.contrast);
		this.updateSliderProgrammatically(this.saturationControl, 
			isNaN(filterData.saturation) ? 1.0 : filterData.saturation);
		this.updateSliderProgrammatically(this.hueControl, 
			isNaN(filterData.hue) ? 0 : filterData.hue);
		this.updateSliderProgrammatically(this.gammaRControl, 
			isNaN(filterData.gammaR) ? 1.0 : filterData.gammaR);
		this.updateSliderProgrammatically(this.gammaGControl, 
			isNaN(filterData.gammaG) ? 1.0 : filterData.gammaG);
		this.updateSliderProgrammatically(this.gammaBControl, 
			isNaN(filterData.gammaB) ? 1.0 : filterData.gammaB);
		this.updateSliderProgrammatically(this.grainControl, 
			isNaN(filterData.grain) ? 0 : filterData.grain);
		
		const customEffectRadio = this.container.querySelector("#customEffect");
		if (customEffectRadio) {
			customEffectRadio.checked = true;
		}
		this.handleEffectChange();
	}
	applyFiltersByValues(
		brightnessValue,
		contrastValue,
		saturationValue,
		hueValue,
		gammaRValue,
		gammaGValue,
		gammaBValue,
		CCM,
		SLT
	) {
		if (!this.processedPixels) return;
		const imageData = this.ctx.getImageData(
			0,
			0,
			this.imgWidth,
			this.imgHeight
		);
		const pixels = imageData.data;
		pixels.set(this.processedPixels);
		if (window.V105Filters?.applyMatrix) {
			const colorCorrectionMatrix = CCM.map((row) =>
				row.map((val) => val / 1024)
			);
			window.V105Filters.applyMatrix(
				pixels,
				this.imgWidth,
				this.imgHeight,
				colorCorrectionMatrix
			);
		}
		if (window.V105Filters?.applyGammaTableRGBA) {
			window.V105Filters.applyGammaTableRGBA(
				pixels,
				this.imgWidth,
				this.imgHeight,
				window.V105Filters.gamma_table
			);
		}
		if (window.V105Filters?.applySegDLookupTableRGBA) {
			const segDLookupTable = Array.from({ length: 256 }, (_, i) => [
				SLT[0][i],
				SLT[1][i],
				SLT[2][i],
			]);
			window.V105Filters.applySegDLookupTableRGBA(
				pixels,
				this.imgWidth,
				this.imgHeight,
				segDLookupTable
			);
		}
		if (window.V105Filters?.applyGrainLevelNoise) {
			const grain = parseFloat(this.grainControl.value);
			window.V105Filters.applyGrainLevelNoise(
				pixels,
				this.imgWidth,
				this.imgHeight,
				grain,
				this.imgWidth,
				this.imgHeight
			);
		}
		this.ctx.putImageData(imageData, 0, 0);
		this.updateHiddenTables(CCM, SLT);
	}
	updateHiddenTables(CCM, SLT) {
		const colorCorrectionMatrix = CCM.map((row) =>
			row.map((val) => val / 1024)
		);
		this.updateHiddenTable("colorCorrectionMatrixTable", colorCorrectionMatrix);
		const segDLookupTable = Array.from({ length: 256 }, (_, i) => [
			SLT[0][i],
			SLT[1][i],
			SLT[2][i],
		]);
		this.updateHiddenSegTable("segDLookupTable", segDLookupTable);
	}
}
